(function () {
  const CRIIPTO_DOMAIN = "lieviti.criipto.id";
  const CLIENT_ID = "11001c96-e166-4d66-b9a4-44eb9c7c847c";
  const CALLBACK_URL = "https://www.lieviti.dk/pages/age-verification-callback";
  const VERIFIED_COOKIE = "mitid_verified";
  const REDIRECT_KEY = "mitid_redirect";
  const STATE_KEY = "mitid_state";
  const DEBUG_MODE = window.location.search.includes("debug=1");

  // ===== DEBUG OVERLAY =====
  function showDebug(message) {
    if (!DEBUG_MODE) return;
    let overlay = document.getElementById("mitid-debug-overlay");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.id = "mitid-debug-overlay";
      Object.assign(overlay.style, {
        position: "fixed",
        bottom: "10px",
        right: "10px",
        width: "320px",
        maxHeight: "50vh",
        overflowY: "auto",
        background: "rgba(0,0,0,0.85)",
        color: "#0f0",
        fontFamily: "monospace",
        fontSize: "11px",
        padding: "10px",
        borderRadius: "8px",
        zIndex: 99999,
        whiteSpace: "pre-wrap",
      });
      document.body.appendChild(overlay);
    }
    overlay.innerText += `\n${new Date().toLocaleTimeString()} — ${message}`;
  }

  function setCookie(name, value, days = 7) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};path=/;SameSite=None;Secure`;
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function safeSet(key, value) {
    try { sessionStorage.setItem(key, value); } catch {}
    try { localStorage.setItem(key, value); } catch {}
    setCookie(key, value);
    showDebug(`Saved ${key}: ${value}`);
  }

  function safeGet(key) {
    const v = sessionStorage.getItem(key) || localStorage.getItem(key) || getCookie(key);
    showDebug(`Loaded ${key}: ${v}`);
    return v;
  }

  function parseJwt(token) {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const json = JSON.parse(atob(base64));
      showDebug(`Parsed JWT: ${JSON.stringify(json, null, 2)}`);
      return json;
    } catch {
      showDebug("Failed to parse JWT");
      return null;
    }
  }

  function buildAuthUrl(redirectAfter) {
    const state = "state-" + Math.random().toString(36).substring(2);
    safeSet(STATE_KEY, state);
    safeSet(REDIRECT_KEY, redirectAfter);
    const url =
      `https://${CRIIPTO_DOMAIN}/oauth2/authorize` +
      `?client_id=${CLIENT_ID}` +
      `&response_type=id_token` +
      `&response_mode=query` +
      `&scope=openid` +
      `&redirect_uri=${encodeURIComponent(CALLBACK_URL)}` +
      `&nonce=${Date.now()}` +
      `&state=${state}` +
      `&prompt=login` +
      `&acr_values=urn:grn:authn:mitid:loa_substantial`;
    showDebug(`Redirecting to MitID: ${url}`);
    return url;
  }

  function isVerified() {
    return getCookie(VERIFIED_COOKIE) === "true";
  }

  // ===== HANDLE CALLBACK =====
  const hashParams = new URLSearchParams(window.location.hash.substring(1));
  const queryParams = new URLSearchParams(window.location.search);
  const idToken = hashParams.get("id_token") || queryParams.get("id_token");

  if (idToken) {
    const state = hashParams.get("state") || queryParams.get("state");
    const storedState = safeGet(STATE_KEY);
    showDebug(`Callback detected. state=${state}, stored=${storedState}`);

    if (state === storedState) {
      const claims = parseJwt(idToken);
      if (claims?.sub) {
        setCookie(VERIFIED_COOKIE, "true", 7);
        safeSet(VERIFIED_COOKIE, "true");
        const redirect = safeGet(REDIRECT_KEY) || "/checkout";
        showDebug(`✅ Verification success. Redirecting to ${redirect}`);
        window.location.href = redirect;
      } else {
        showDebug("❌ JWT invalid or missing sub");
      }
    } else {
      showDebug("❌ State mismatch — possible iOS storage loss");
    }

    window.history.replaceState({}, document.title, window.location.pathname);
    return;
  }

  document.addEventListener("DOMContentLoaded", () => {
    const checkoutBtn = document.querySelector(
      'form[action*="/checkout"] [type="submit"], .cart__checkout-button, [name="checkout"], a[href*="/checkout"]'
    );

    if (checkoutBtn) {
      checkoutBtn.addEventListener("click", (e) => {
        if (!isVerified()) {
          e.preventDefault();
          safeSet(REDIRECT_KEY, "/checkout");
          const authUrl = buildAuthUrl("/checkout");
          showDebug("Redirecting to MitID...");
          window.location.href = authUrl;
        }
      });
    }

    showDebug("MitID script loaded. Verified=" + isVerified());
  });
})();
